import $ from "jquery";
import { computePosition, autoPlacement, shift, arrow, offset } from "@floating-ui/dom";


const tooltip = () => {
  // const opener = $(".tooltip-opener, .product-buy__disabled .info__icon");

  let tooltipPortal;

  const createTooltipPortal = () => {
    if (document.querySelectorAll(".tooltip-portal").length === 0) {
      tooltipPortal = document.createElement("div");
      tooltipPortal.classList.add("tooltip-portal");
      document.body.appendChild(tooltipPortal);
    }
  };

  function closeTooltip(e) {
    e.preventDefault();
    if (tooltipPortal === e.target || e.target === document) {
      // $(".tooltip__dropdown, .product-buy__disabled .info__text").fadeOut(300);
      tooltipPortal.remove();
      document.removeEventListener("mouseup", closeTooltip);
      document.removeEventListener("scroll", closeTooltip);
    }
  }

  $(document).on(
    "click",
    ".tooltip-opener, .product-buy__disabled .info__icon",
    function openTooltip(e) {
      e.preventDefault();

      createTooltipPortal();

      const tooltipMenu = $(this).siblings(".tooltip__dropdown, .info__text");
      const tooltipMenuElSrc = tooltipMenu[0];
      
      tooltipPortal.innerHTML = ""; // Clear portal content
      // Copy tooltip content to portal
      const tooltipMenuEl = tooltipPortal.appendChild(tooltipMenuElSrc.cloneNode(true));
      const tooltipOpener = e.currentTarget;


      setTimeout(() => {
        computePosition(tooltipOpener, tooltipMenuEl, {
          placement: "top",
          strategy: "absolute",
          middleware: [
            autoPlacement(),
            shift({
              padding: 16,
            }),
            offset(4),
          ],
        }).then(({ x, y }) => {
          const tooltipStyles = {
            left: `${x}px`,
            top: `${y}px`,
            opacity: 1,
            visibility: "visible",
          }

          Object.assign(tooltipMenuEl.style, tooltipStyles)
          Object.assign(tooltipPortal.style, {
            pointerEvents: "all",
          })
        })
        // tooltipMenuEl.fadeToggle(300);
      }, 1);  

      document.addEventListener("mouseup", closeTooltip);
      document.addEventListener("scroll", closeTooltip);
    }
  );

  $(document).on("click", ".tooltip__dropdown", () => {
    // e.preventDefault();
  });

  // document.addEventListener("mouseup", closeTooltip);
};

export default tooltip;
